function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClinicAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e8260d10-f04e-4949-b225-dc774db83503",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 34 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a7d426f4-5905-4c3d-85c2-fb669eb0b940"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -1008,
    cy: -1396.5,
    r: 68,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bed85a01-0291-4dce-a4c5-8fe98a9e1d2e"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 266.01,
    cy: -491.99,
    r: 22,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba065972-aaec-48ef-b830-4f0902cbce93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266-496.18a5.29,5.29,0,0,0-5.29,5.29,5.3,5.3,0,0,0,5.29,5.3,5.31,5.31,0,0,0,5.3-5.3,5.3,5.3,0,0,0-5.3-5.29m0,9.09a3.8,3.8,0,0,1-3.8-3.8,3.8,3.8,0,0,1,3.8-3.79,3.8,3.8,0,0,1,3.8,3.79,3.8,3.8,0,0,1-3.8,3.8",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f7cc5c5e-abd0-4291-be46-7c6efd04f9a8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.21,2.86a4.74,4.74,0,0,0-6.36,2.39,5.69,5.69,0,0,0,0,3.82,4.77,4.77,0,0,0,5.91,2.55,5.28,5.28,0,0,0,2.6-2.33,5.47,5.47,0,0,0,.26-3.72A5.51,5.51,0,0,0,133.21,2.86ZM130.28.76a6.33,6.33,0,0,1,6.33,2.93,6.52,6.52,0,0,1-1.54,8.6,5.34,5.34,0,0,1-3.91,1.21,4.12,4.12,0,0,1-2.68-.54,6.45,6.45,0,0,1,1.8-12.2ZM142.69,9.5,144,10.77l-2,2,2,1.93-.56.58a2.15,2.15,0,0,1-.74.57,4.94,4.94,0,0,1-1.06-.9l-.9-.91-1,.92-.94.94-.63-.5c-.35-.29-.62-.57-.62-.67a4.82,4.82,0,0,1,.91-1.07l.92-.89-.92-.92a5.77,5.77,0,0,1-.91-1.06,2.68,2.68,0,0,1,.56-.71l.57-.58,2,2Zm-19,2.4h0c.06.06.28.39.49.7l.38.57-.78.76c-1.73,1.66-2,2.68-2,7,0,2.67,0,3.18.24,3.38s1,.22,6.75.23h3.6c5.94,0,7.94-.05,8.07-.17a10.13,10.13,0,0,0,.18-3V18.47h1.78v3.26c0,3.12-.15,3.54-1.14,4.16l-.57.36-9,0H128c-3.68,0-5.62-.05-6-.13a2.07,2.07,0,0,1-1.3-.74c-.52-.57-.67-.95-.68-2.82v-.42c0-.53,0-1.15,0-1.9a15.26,15.26,0,0,1,.33-4l0-.18a8.49,8.49,0,0,1,2.33-3.51c.48-.43.91-.74,1-.67Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a02b90bf-3219-4bd2-a561-d9526c818706"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.85,4.55a5.69,5.69,0,0,0,0,3.82,4.77,4.77,0,0,0,5.91,2.55,5.28,5.28,0,0,0,2.6-2.33,5.47,5.47,0,0,0,.26-3.72,5.51,5.51,0,0,0-2.44-2.71A4.74,4.74,0,0,0,77.85,4.55ZM87.61,3a6.52,6.52,0,0,1-1.54,8.6,5.34,5.34,0,0,1-3.91,1.21,4.12,4.12,0,0,1-2.68-.54A6.45,6.45,0,0,1,81.28.06,6.33,6.33,0,0,1,87.61,3ZM97.3,8.25a1.07,1.07,0,0,1,1-.06,1.37,1.37,0,0,1,.93,1.37v.07c0,.63.07.54-4.17,5-3.95,4.16-4.19,4.45-4.73,4.46h-.3c-.68,0-.85-.17-2.4-2.09S86,14.9,86,14.51A1.58,1.58,0,0,1,87,13.14c.82-.35,1.2-.17,2.3,1.14a11.54,11.54,0,0,0,1,1.13c.18-.25,1.74-1.87,3.34-3.51l.44-.45,1.26-1.28.39-.39C96.58,8.91,97.22,8.28,97.3,8.25ZM74.69,11.2h0c.05,0,.23.32.42.59l.07.11.38.57-.78.76c-1.73,1.66-2,2.68-2,7,0,2.67,0,3.18.24,3.38l0,0,0,0c.32.14,1.52.18,6.68.18h3.6c5.94,0,7.94-.05,8.07-.17a8.59,8.59,0,0,0,.18-2.78V19.77H93.4V21c0,3-.14,3.51-1.05,4.1l-.09.06-.57.36-9,0H79c-3.68,0-5.62-.05-6-.13a2.07,2.07,0,0,1-1.3-.74c-.52-.57-.67-.95-.68-2.82v-.42c0-.53,0-1.15,0-1.9.06-2.77.12-3.36.38-4.2a8.49,8.49,0,0,1,2.33-3.51,3.7,3.7,0,0,1,.91-.68Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b4eaca0b-6e5b-4df1-9bf3-7b9e0683fed1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,31.86A1,1,0,0,1,33.07,33c-.69.05-1-.37-1.09-1.07a21.63,21.63,0,0,0-.45-3c-1.29-5-4.82-7.8-10.12-8.07a15,15,0,0,0-7.11,1.08c-.68.31-1.25.19-1.52-.5s.16-1.17.79-1.43a14.71,14.71,0,0,1,6.61-1.18,15,15,0,0,1,5,.58c5,1.55,7.63,5.2,8.61,10.21A19,19,0,0,1,34,31.86M11.67,8.41a8.38,8.38,0,1,1,8.39,8.34,8.38,8.38,0,0,1-8.39-8.34m2-.05A6.4,6.4,0,0,0,20,14.72a6.35,6.35,0,1,0-6.3-6.36m.48,19.34c1,.83.56,3.59-.56,4.24a1.3,1.3,0,0,0-.81,1.32c0,1.59-2.33,3.18-3.83,2.6A1.14,1.14,0,0,0,7.63,36a3.12,3.12,0,0,1-4.56-1.39,1,1,0,0,0-.9-.83A3.12,3.12,0,0,1,.42,29.32.92.92,0,0,0,.5,28.18,3.06,3.06,0,0,1,2.89,24a.94.94,0,0,0,.95-.64,3.11,3.11,0,0,1,4.76-.78,1.09,1.09,0,0,0,1.31.3c1.31-.31,3.46,1.4,3.46,2.86-.38.8.12,1.33.81,1.93m-2,1a2.18,2.18,0,0,1-.94-2.46c.19-.45.12-.68-.23-.92s-.47-.6-1-.31a2.1,2.1,0,0,1-2.6-.74c-.24-.4-.45-.53-.88-.38s-.77,0-.89.61a2,2,0,0,1-2.2,1.53c-.6-.11-.71.23-.91.56s-.33.56,0,1a2,2,0,0,1-.11,2.61c-.37.35-.45.59-.23,1s.28.66.85.64a2.09,2.09,0,0,1,1.93,1.78.69.69,0,0,0,.61.76c.37.09.7.28,1.08-.18a2,2,0,0,1,2.69-.41c.43.29.66.14,1-.07s.59-.41.47-1a2,2,0,0,1,1.4-2.31c.59-.18.42-.6.53-.91,0-.51,0-.51-.53-.83m-2,.69a3.08,3.08,0,0,1-3,3.07,3.13,3.13,0,0,1-3.09-3.1,3.06,3.06,0,0,1,3.08-3,3,3,0,0,1,3,3m-2-.08A1,1,0,0,0,7,28.42a.93.93,0,0,0-1,1.09.91.91,0,0,0,1,.94c.65,0,1-.39,1-1.12",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc946502-ce7e-4592-9656-7865b3f1e078"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -313,
    y: -344,
    width: 1528,
    height: 860,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b4eaca0b-6e5b-4df1-9bf3-7b9e0683fed1)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#bc946502-ce7e-4592-9656-7865b3f1e078)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 36.04,
    height: 39.15,
    style: {
      fill: "#132044"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClinicAdmin);
export default __webpack_public_path__ + "static/media/icon_clinic_admin.2841cc89e8e18c9585437763bdfa6fce.svg";
export { ForwardRef as ReactComponent };